/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AnswerModel } from '../../models/answer-model';
import { QuestionModel } from '../../models/question-model';

export interface QuestionnaireInstanceNextPostParams {
  questionnaireInstanceGuid: string;
  language?: string;
  body?: AnswerModel;
}

export function questionnaireInstanceNextPost(
  http: HttpClient,
  rootUrl: string,
  params: QuestionnaireInstanceNextPostParams,
  context?: HttpContext,
): Observable<StrictHttpResponse<QuestionModel>> {
  const rb = new RequestBuilder(
    rootUrl,
    questionnaireInstanceNextPost.PATH,
    'post',
  );
  if (params) {
    rb.path('questionnaireInstanceGuid', params.questionnaireInstanceGuid, {
      style: 'simple',
    });
    rb.body(params.body, 'application/json');
    if (params.language) {
      rb.query('languageCode', params.language);
    }
  }

  return http
    .request(rb.build({ responseType: 'json', accept: '*/*', context }))
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<QuestionModel>;
      }),
    );
}

questionnaireInstanceNextPost.PATH =
  '/api/v1/questionnaire-instances/{questionnaireInstanceGuid}/questions/next';
